import { faBookOpen, faBoxArchive, faCameraRetro, faCoins, faCubes, faDisplay, faDragon, faEarthAmerica, faHourglass, faMartiniGlass, faObjectGroup, faPaintBrush, faPencil, faT, faTrafficLight, faXmark } from "@fortawesome/free-solid-svg-icons";
import { imageStyleListProps, styleImageGeneration } from "../../types/imageStudio/images";
import { faMoon, faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InfoPopoverButton } from "../../components/app/ImageStudio/InfoButton";
//images
import flower3D from '../../assets/stylesExamples/purpleFlowers3D.png';
import flowerAnime from '../../assets/stylesExamples/purpleFlowersAnime.png';
import flowerArtistic from '../../assets/stylesExamples/purpleFlowersArtistic.png';
import flowerBrickToy from '../../assets/stylesExamples/purpleFlowersBrickToy.png';
import flowerCharocal from '../../assets/stylesExamples/purpleFlowersCharocal.png';
import flowerCinematic from '../../assets/stylesExamples/purpleFlowersCinematic.png';
import flowerComic from '../../assets/stylesExamples/purpleFlowersComic.png';
import flowerCyberpunk from '../../assets/stylesExamples/purpleFlowersCyberpunk.png';
import flowerDigitalArt from '../../assets/stylesExamples/purpleFlowersDigitalArt.png';
import flowerFantasy from '../../assets/stylesExamples/purpleFlowersFantasy.png';
import flowerGlassArt from '../../assets/stylesExamples/purpleFlowersGlassArt.png'
import flowerGolden from '../../assets/stylesExamples/purpleFlowersGoldenArt.png'
import flowerGothic from '../../assets/stylesExamples/purpleFlowersGothic.png';
import flowerLineArt from '../../assets/stylesExamples/purpleFlowersLineArt.png';
import flowerMinimalistic from '../../assets/stylesExamples/purpleFlowersMinimalistic.png';
import flowerOilPaint from '../../assets/stylesExamples/purpleFlowersOilPainting.png';
import flowerPapercraft from '../../assets/stylesExamples/purpleFlowersPapercraft.png';
import flowerPhotographic from '../../assets/stylesExamples/purpleFlowersPhotographic.png';
import flowerRealistic from '../../assets/stylesExamples/purpleFlowersRealistic.png';
import flowerStorybook from '../../assets/stylesExamples/purpleFlowersStorybook.png';
import flowerSurreal from '../../assets/stylesExamples/purpleFlowersSurreal.png';
import flowerVintage from '../../assets/stylesExamples/purpleFlowersVintage.png';
import flowerWatercolor from '../../assets/stylesExamples/purpleFlowersWaterColor.png';
import flowerNoir from '../../assets/stylesExamples/purpleFlowersNoir.png';
import flowerNone from '../../assets/stylesExamples/purpleFlowersNone.png';
import flowerWoodenBlocks from '../../assets/stylesExamples/purpleFlowersWoodenBlocks.png';
import flowerBlockWorld from '../../assets/stylesExamples/purpleFlowersBlockWorld.png';
//text styles
import flowerTextGolden from '../../assets/stylesExamples/purpleFlowersGolden-text.png';
import flowerTextCandy from '../../assets/stylesExamples/purpleFlowersCandy.png';
import flowerTextCrystal from '../../assets/stylesExamples/purpleFlowersCrystal.png';
import flowerTextDark from '../../assets/stylesExamples/purpleFlowersDark.png';
import flowerTextFire from '../../assets/stylesExamples/purpleFlowersFire.png';
import flowerTextIce from '../../assets/stylesExamples/purpleFlowersIce.png';
import flowerTextFlower from '../../assets/stylesExamples/purpleFlowersFlowerPower.png';
import flowerTextGalaxy from '../../assets/stylesExamples/purpleFlowersGalaxy.png';
import flowerTextNature from '../../assets/stylesExamples/prupleFlowersNature.png';
import flowerTextSmoke from '../../assets/stylesExamples/purpleFlowersSmoke.png';
import flowerTextMetallic from '../../assets/stylesExamples/purpleFlowersMetallic.png';
import flowerTextTransition from '../../assets/stylesExamples/purpleFlowersTransition.png';
import flowerTextLiquid from '../../assets/stylesExamples/purpleFlowersLiquid.png';
import flowerTextNeon from '../../assets/stylesExamples/purpleFlowersNeon.png';
import flowerTextMushroom from '../../assets/stylesExamples/purpleFlowerMushrooms.png';

import sengiTextGolden from '../../assets/stylesExamples/sengiTextGolden2.png';
import sengiTextCandy from '../../assets/stylesExamples/sengiTextCandy2.png';
import sengiTextCrystal from '../../assets/stylesExamples/sengiTextCrystal2.png';
import sengiTextDark from '../../assets/stylesExamples/sengiTextDark1.png';
import sengiTextFire from '../../assets/stylesExamples/sengiTextFire2.png';
import sengiTextIce from '../../assets/stylesExamples/sengiTextIce2.png';
import sengiTextFlower from '../../assets/stylesExamples/sengiTextFlower1.png';
import sengiTextGalaxy from '../../assets/stylesExamples/sengiTextGalaxy2.png';
import sengiTextNature from '../../assets/stylesExamples/sengiTextNature2.png';
import sengiTextSmoke from '../../assets/stylesExamples/sengiTextSmoke2.png';
import sengiTextMetallic from '../../assets/stylesExamples/sengiTextMetallic2.png';
import sengiTextTransition from '../../assets/stylesExamples/sengiTextTransition1.png';
import sengiTextLiquid from '../../assets/stylesExamples/sengiTextLiquid1.png';
import sengiTextNeon from '../../assets/stylesExamples/sengiTextNeon2.png';
import sengiTextMushroom from '../../assets/stylesExamples/sengiTextMushrooms6.png';

export const stylesList: imageStyleListProps[] = [
    {
        item: 'none',
        name: 'None',
        category: ["None"],
        icon: faXmark,
        description: (
            <div>
                <p>No additional style treatment.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerNone} width='200px' alt="purple flowers example" />
            </div>
        )
    },
    {
        item: '3d render',
        name: '3D render',
        icon: faCubes,
        category: ['Craft & Material'],
        description: (
            <div>
                <p>High-quality CGI look with realistic materials, lighting, and geometry.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flower3D} width='200px' alt="purple flowers 3d render example" />
            </div>
        )
    },
    {
        item: 'anime',
        name: 'Anime',
        icon: faDragon,
        category: ['Illustration'],
        description: (
            <div>
                <p>Clean anime illustration with stylized forms, outlines, and soft cel shading.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerAnime} width='200px' alt="purple flowers anime example" />
            </div>
        )
    },
    {
        item: 'artistic',
        name: 'Artistic',
        icon: faPaintBrush,
        category: ['Illustration'],
        description: (
            <div>
                <p>Expressive painterly interpretation with rich mood and creative atmosphere.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerArtistic} width='200px' alt="purple flowers artistic example" />
            </div>
        )
    },
    {
        item: 'block-world',
        name: 'Block world',
        icon: faCubes,
        category: ['Toy & Block','Experimental'],
        description: (
            <div>
                <p>Stylized block-world look built from simple square and cubic shapes.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerBlockWorld} width='200px' alt="purple flowers block world example" />
            </div>
        )
    },
    {
        item: 'brick-toy',
        name: 'Brick-Toy',
        icon: faCubes,
        category: ['Toy & Block','Experimental'],
        description: (
            <div>
                <p>Playful plastic brick construction with modular shapes and glossy toy materials.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerBrickToy} width='200px' alt="purple flowers brick toy example" />
            </div>
        )
    },
    {
        item: 'charcoal',
        name: 'Charcoal',
        icon: faPencil,
        category: ['Painting','Experimental'],
        description: (
            <div>
                <p>Expressive charcoal drawing with rough texture, shading, and paper grain.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerCharocal} width='200px' alt="purple flowers charcoal example" />
            </div>
        )
    },
    {
        item: 'cinematic',
        name: 'Cinematic',
        icon: faCameraRetro,
        category: ['Cinema & Mood'],
        description: (
            <div>
                <p>Movie-like lighting, dramatic framing, depth, and cinematic color grading.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerCinematic} width='200px' alt="purple flowers cinematic example" />
            </div>
        )
    },
    {
        item: 'comic',
        name: 'Comic',
        icon: faBookOpen,
        category: ['Illustration'],
        description: (
            <div>
                <p>Bold comic illustration with ink outlines, graphic shading, and strong contrast.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerComic} width='200px' alt="purple flowers comic example" />
            </div>
        )
    },
    {
        item: 'cyberpunkt',
        name: 'Cyberpunk',
        icon: faTrafficLight,
        category: ['Lights','Experimental'],
        description: (
            <div>
                <p>Futuristic neon atmosphere with reflective surfaces and sci-fi color grading.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerCyberpunk} width='200px' alt="purple flowers cyberpunk example" />
            </div>
        )
    },
    {
        item: 'digital art',
        name: 'Digital Art',
        icon: faDisplay,
        category: ['Illustration'],
        description: (
            <div>
                <p>Polished digital painting with sharp detail, depth, and vibrant rendering.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerDigitalArt} width='200px' alt="purple flowers digital art example" />
            </div>
        )
    },
    {
        item: 'fantasy',
        name: 'Fantasy',
        icon: faDragon,
        category: ['Fantasy & Dark','Experimental'],
        description: (
            <div>
                <p>Magical fantasy atmosphere with enchanted lighting and mystical detail.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerFantasy} width='200px' alt="purple flowers fantasy example" />
            </div>
        )
    },
    {
        item: 'glass-art',
        name: 'Glass Art',
        icon: faMartiniGlass,
        category: ['Craft & Material','Experimental'],
        description: (
            <div>
                <p>Transparent glass-inspired surfaces with refraction, highlights, and crystal depth.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerGlassArt} width='200px' alt="purple flowers glass art example" />
            </div>
        )
    },
    {
        item: 'golden-art',
        name: 'Golden Art',
        category: ['Craft & Material','Experimental'],
        icon: faCoins,
        description: (
            <div>
                <p>Liquid-gold artistic treatment with metallic shine and elegant reflective surfaces.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerGolden} width='200px' alt="purple flowers golden art example" />
            </div>
        )
    },
    {
        item: 'gothic',
        name: 'Gothic',
        icon: faMoon,
        category: ['Fantasy & Dark','Experimental'],
        description: (
            <div>
                <p>Dark elegant gothic mood with dramatic contrast and refined antique accents.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerGothic} width='200px' alt="purple flowers gothic example" />
            </div>
        )
    },
    {
        item: 'line-art',
        name: 'Line-Art',
        category: ['Illustration'],
        icon: faPencil,
        description: (
            <div>
                <p>Clean ink-like outlines, simplified detail, and highly readable shapes.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerLineArt} width='200px' alt="purple flowers line art example" />
            </div>
        )
    },
    {
        item: 'minimalistic',
        name: 'Minimalistic',
        category: ['Cinema & Mood','Experimental'],
        icon: faBoxArchive,
        description: (
            <div>
                <p>Clean simplified design with elegant shapes, subtle colors, and negative space.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerMinimalistic} width='200px' alt="purple flowers minimalistic example" />
            </div>
        )
    },
    {
        item: 'noir',
        name: 'Noir',
        category: ['Cinema & Mood'],
        icon: faMoon,
        description: (
            <div>
                <p>Moody noir look with dramatic shadows, monochrome contrast, and mystery.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerNoir} width='200px' alt="purple flowers noir example" />
            </div>
        )
    },
    {
        item: 'oil-painting',
        name: 'Oil Painting',
        category: ['Painting'],
        icon: faPaintBrush,
        description: (
            <div>
                <p>Traditional oil painting with visible brush strokes and rich pigments.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerOilPaint} width='200px' alt="purple flowers oil painting example" />
            </div>
        )
    },
    {
        item: 'papercraft',
        name: 'Papercraft',
        category: ['Craft & Material'],
        icon: faPaperPlane,
        description: (
            <div>
                <p>Layered cut-paper look with tactile texture, folded details, and soft shadows.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerPapercraft} width='200px' alt="purple flowers papercraft example" />
            </div>
        )
    },
    {
        item: 'photographic',
        name: 'Photographic',
        category: ['Realism'],
        icon: faCameraRetro,
        description: (
            <div>
                <p>Professional camera-style realism with natural lens behavior and authentic textures.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerPhotographic} width='200px' alt="purple flowers photographic example" />
            </div>
        )
    },
    {
        item: 'realistic',
        name: 'Realistic',
        category: ["Realism"],
        icon: faEarthAmerica,
        description: (
            <div>
                <p>Natural photographic realism with believable light, materials, and details.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerRealistic} width='200px' alt="purple flowers realistic example" />
            </div>
        )
    },
    {
        item: 'storybook',
        name: 'Storybook',
        category: ['Illustration'],
        icon: faBookOpen,
        description: (
            <div>
                <p>Warm illustrated storybook style with charming textures and narrative softness.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerStorybook} width='200px' alt="purple flowers storybook example" />
            </div>
        )
    },
    {
        item: 'surreal',
        name: 'Surreal',
        icon: faHourglass,
        category: ['Experimental'],
        description: (
            <div>
                <p>Dreamlike artistic style with imaginative distortions and symbolic atmosphere.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerSurreal} width='200px' alt="purple flowers surreal example" />
            </div>
        )
    },
    {
        item: 'vintage',
        name: 'Vintage',
        category: ['Cinema & Mood'],
        icon: faCameraRetro,
        description: (
            <div>
                <p>Retro film mood with faded colors, nostalgic tones, and subtle grain.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerVintage} width='200px' alt="purple flowers vintage example" />
            </div>
        )
    },
    {
        item: 'water-color',
        name: 'Water Color',
        category: ['Painting'],
        icon: faPaintBrush,
        description: (
            <div>
                <p>Soft watercolor washes, delicate edges, and light paper texture.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerWatercolor} width='200px' alt="purple flowers watercolor example" />
            </div>
        )
    },
    {
        item: 'wooden-blocks',
        name: 'Wooden Blocks',
        category: ['Toy & Block','Experimental'],
        icon: faCubes,
        description: (
            <div>
                <p>Handcrafted wooden block construction with warm grain and toy-like simplicity.</p>

                <p>
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerWoodenBlocks} width='200px' alt="purple flowers wooden blocks example" />
            </div>
        )
    },
    {
        item: 'textCandy',
        name: 'Candy',
        category: ['Text Styles','Experimental'],
        icon: faT,
        description: (
            <div>
                <p>Glossy candy style with colorful coating, sugar glaze, and playful dessert-like surfaces.</p>

                <p>
                    <i>Example Text: "SENGI"</i>
                </p>

                <img src={sengiTextCandy} width="200px" alt="text candy style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextCandy} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textCrystal',
        name: 'Crystal',
        category: ['Text Styles','Experimental'],
        icon: faT,
        description: (
            <div>
                <p>Crystal gemstone look with transparent facets, sparkling highlights, and refractive depth.</p>

                <p>
                    <i>Example: "SENGI"</i>
                </p>

                <img src={sengiTextCrystal} width="200px" alt="text crystal style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextCrystal} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textDark',
        name: 'Dark',
        category: ['Text Styles'],
        icon: faT,
        description: (
            <div>
                <p>Dark atmospheric style with deep shadows, dramatic contrast, and mysterious cinematic mood.</p>

                <p>
                    <i>Example: "SENGI"</i>
                </p>

                <img src={sengiTextDark} width="200px" alt="text dark style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextDark} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textFire',
        name: 'Fire',
        category: ['Text Styles'],
        icon: faT,
        description: (
            <div>
                <p>Blazing fire style with flames, glowing embers, sparks, and intense heat effects.</p>

                <p>
                    <i>Example: "SENGI"</i>
                </p>

                <img src={sengiTextFire} width="200px" alt="text fire style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextFire} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textFlower',
        name: 'Flower Power',
        category: ['Text Styles','Experimental'],
        icon: faT,
        description: (
            <div>
                <p>Floral style made from blossoms, petals, vines, and colorful botanical details.</p>

                <p>
                    <i>Example: "SENGI"</i>
                </p>

                <img src={sengiTextFlower} width="200px" alt="text flower style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextFlower} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textGalaxy',
        name: 'Galaxy',
        category: ['Text Styles'],
        icon: faT,
        description: (
            <div>
                <p>Cosmic galaxy style with nebula colors, star-filled surfaces, and deep space atmosphere.</p>

                <p>
                    <i>Example: "SENGI"</i>
                </p>

                <img src={sengiTextGalaxy} width="200px" alt="text galaxy style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextGalaxy} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textGolden',
        name: 'Golden Font',
        category: ['Text Styles'],
        icon: faT,
        description: (
            <div>
                <p>Flowing liquid-gold style with molten metallic shine, reflective highlights, and elegant fluid edges.</p>

                <p>
                    <i>Example: "SENGI"</i>
                </p>

                <img src={sengiTextGolden} width="200px" alt="text golden style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextGolden} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textIce',
        name: 'Ice',
        category: ['Text Styles','Experimental'],
        icon: faT,
        description: (
            <div>
                <p>Frozen ice style with frosted edges, crystalline surfaces, cold highlights, and winter texture.</p>

                <p>
                    <i>Example: "SENGI"</i>
                </p>

                <img src={sengiTextIce} width="200px" alt="text ice style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextIce} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textLiquid',
        name: 'Liquid',
        category: ['Text Styles'],
        icon: faT,
        description: (
            <div>
                <p>Liquid material style with flowing surfaces, glossy reflections, droplets, and splash-like motion.</p>

                <p>
                    <i>Example: "SENGI"</i>
                </p>

                <img src={sengiTextLiquid} width="200px" alt="text liquid style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextLiquid} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textMetallic',
        name: 'Metallic',
        category: ['Text Styles'],
        icon: faT,
        description: (
            <div>
                <p>Premium metallic style with brushed metal, chrome gradients, reflective surfaces, and polished shine.</p>

                <p>
                    <i>Example: "SENGI"</i>
                </p>

                <img src={sengiTextMetallic} width="200px" alt="text metallic style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextMetallic} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textMushroom',
        name: 'Mushrooms',
        category: ['Text Styles','Experimental'],
        icon: faT,
        description: (
            <div>
                <p>
                    Fantasy woodland style built from mushrooms, moss, fungi, spores, and organic forest details.
                    The letters become part of a magical natural ecosystem while remaining readable.
                </p>

                <p>
                    <i>Example: "SENGI"</i>
                </p>

                <img src={sengiTextMushroom} width="200px" alt="text mushroom style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextMushroom} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textNature',
        name: 'Natural',
        category: ['Text Styles','Experimental'],
        icon: faT,
        description: (
            <div>
                <p>Organic nature style with moss, leaves, vines, bark textures, and forest-inspired materials.</p>

                <p>
                    <i>Example: "SENGI"</i>
                </p>

                <img src={sengiTextNature} width="200px" alt="text nature style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextNature} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textNeon',
        name: 'Neon',
        category: ['Text Styles'],
        icon: faT,
        description: (
            <div>
                <p>Vibrant neon light style with glowing tubes, colorful bloom, luminous edges, and electric atmosphere.</p>

                <p>
                    <i>Example: "SENGI"</i>
                </p>

                <img src={sengiTextNeon} width="200px" alt="text neon style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextNeon} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textSmoke',
        name: 'Smoke',
        category: ['Text Styles'],
        icon: faT,
        description: (
            <div>
                <p>Smoke and mist style with swirling vapor, semi-transparent forms, drifting particles, and soft atmosphere.</p>

                <p>
                    <i>Example: "SENGI"</i>
                </p>

                <img src={sengiTextSmoke} width="200px" alt="text smoke style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextSmoke} width="200px" alt="text candy style example" />
            </div>
        )
    },
    {
        item: 'textTransition',
        name: 'Transition',
        category: ['Text Styles'],
        icon: faT,
        description: (
            <div>
                <p>Smooth gradient transition style with flowing color blends, modern digital polish, and harmonious palettes.</p>

                <p>
                    <i>Example: "SENGI"</i>
                </p>

                <img src={sengiTextTransition} width="200px" alt="text transition style example" />

                <p className="mt-1">
                    <i>Example: "purple flowers"</i>
                </p>

                <img src={flowerTextTransition} width="200px" alt="text candy style example" />
            </div>
        )
    }
]


export const styleCategoryTags = Array.from(
    new Set(stylesList.flatMap(style => style.category ?? []))
).sort();

export const styleFilterGroups = [
    {
        name: "Category",
        tags: styleCategoryTags,
        getItemTags: (style: imageStyleListProps) => style.category ?? []
    }
];

export const renderStyleDropdownItem = (x: imageStyleListProps) => (
    <div className="row p-0 m-0 align-items-center">
        {x.icon && (
            <div className="col-auto p-0 m-0 me-2">
                <FontAwesomeIcon icon={x.icon} />
            </div>
        )}

        <div className="col p-0 m-0">
            <div>{x.name}</div>
            <div className="small opacity-75">{(x.category ?? []).join(", ")}</div>
        </div>

        {x.description && (
            <div className="col-auto mb-1 p-0">
                <InfoPopoverButton width={320} placement="right">
                    <div>{x.description}</div>
                </InfoPopoverButton>
            </div>
        )}
    </div>
);